import * as React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';
import ProfilePitch from 'components/ProfilePitch';
import ProfileSummary from 'modules/misc/components/profile-summary/ProfileSummary';

import BaseInfluencerAgencyPage from 'modules/influencers-agency/pages/BaseInfluencerAgencyPage';
import InfluencersAgencyAdminPanel from 'modules/admin/components/influencers-agencies/admin-panel/InfluencersAgencyAdminPanel';

import { fetchInfluencersAgency } from 'modules/influencers-agency/reducers/influencers-agencies-reducer';

import { isAdmin } from 'utils/account';
import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('../influencers-agencies-pages.i18n.json'));

import { InfluencersAgency, Params } from 'types';

type OwnProps = {
  params: Params
};

type StateProps = {
  agency: InfluencersAgency,
  isAdminMode: boolean
}

type DispatchProps = {
  dispatchFetchInfluencersAgency: (agencyId: number) => Promise<any>
}

type Props = OwnProps & StateProps & DispatchProps;

const InfluencersAgencyProfilePage = ({ params, agency, isAdminMode, dispatchFetchInfluencersAgency }:Props) => {
  const agencyId = Number(params.id);

  useEffect(() => {
    dispatchFetchInfluencersAgency(agencyId);
  }, [params.id]);

  const canEdit = true;
  const editLink = `${isAdminMode ? '/admin' : ''}/influencers-agencies/${agencyId}/settings/profile/edit`;

  return (
    <BaseInfluencerAgencyPage
      agencyId={agencyId}
      documentTitle={__t('influencers_agencies_pages.profile_heading')}
    >
      { isAdminMode && <InfluencersAgencyAdminPanel agency={agency} /> }
      <ProfileSummary
        canEdit={false}
        profile={agency}
        coverImageType="cover-medium"
      >
        <div className="brand-profile__pitch">
          <ProfilePitch
            pitch={agency.pitch}
          />
        </div>
      </ProfileSummary>

      {
        canEdit &&
        <footer className="call-to-action">
          <ActionButton
            link={editLink}
            data={{ qa: 'influencers-agency-profile__button--edit' }}
          >
            {__t('influencers_agencies_pages.edit_profile_action')}
          </ActionButton>
        </footer>
      }
    </BaseInfluencerAgencyPage>
  );
};

const mapStateToProps = ({ influencersAgency, account }): StateProps => ({
  agency: influencersAgency.profile,
  isAdminMode: isAdmin(account.currentAccount, account.roles)
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchInfluencersAgency: (agencyId: number) => dispatch(fetchInfluencersAgency(agencyId))
});

export default connect(mapStateToProps, mapDispatchToProps)(InfluencersAgencyProfilePage);
